export const multipleSearchSeparators = "$**$";
